import { inject } from '@angular/core';
import { TeacherApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const teacherLevelTableConfig = (): TableConfig => {
  const teacherApiService = inject(TeacherApiService);

  return {
    title: 'Cấp độ giáo viên',
    entityName: 'cấp độ giáo viên',
    service: teacherApiService,
    method: 'getTeacherLevels',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text' },
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text' },
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'type', header: 'Loại đào tạo', width: 'min-w-[120px]', sortable: true, type: 'tag', tagType: 'trainingType' },
      { field: 'courseLevel.name', header: 'Cấp độ', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'courseLevel.tagColor', tagTextColor: 'courseLevel.tagTextColor' },
      { field: 'trainer', header: 'Trainer', width: 'min-w-[250px]', sortable: true, type: 'custom' },
      { field: 'deadline', header: 'Hạn chót', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'status', header: 'Trạng thái', width: 'min-w-[120px]', sortable: true, type: 'tag', tagType: 'trainingStatus' },
      { field: 'priority', header: 'Ưu tiên', width: 'min-w-[80px]', sortable: true, type: 'text' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true,
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
